<template>
  <div class="content">
    <!-- 搜索条件 -->
    <div class="block block-form">
      <div class="block-tilte">资金明细</div>
      <el-form :model="searchForm" class="search-form">
        <el-form-item label="提现金额">
          <el-input v-model="searchForm.amountMix" placeholder="最小提现金额" style="width: 150px;" />
          <span style="padding: 0 5px;">至</span>
          <el-input v-model="searchForm.amountMax" placeholder="最大提现金额" style="width: 150px;" />
        </el-form-item>
        <el-form-item label="选择日期">
          <date-picker type="date" placeholder="开始日期" v-model="searchForm.createStartTime" style="width: 150px;">
          </date-picker>
          <span style="padding: 0 5px;">至</span>
          <date-picker type="date" placeholder="结束日期" v-model="searchForm.createEndTime" style="width: 150px;"></date-picker>
        </el-form-item>
        <el-form-item label="处理提现日期">
          <date-picker type="date" placeholder="开始日期" v-model="searchForm.doneStartTime" style="width: 150px;">
          </date-picker>
          <span style="padding: 0 5px;">至</span>
          <date-picker type="date" placeholder="结束日期" v-model="searchForm.doneEndTime" style="width: 150px;"></date-picker>
        </el-form-item>
        <el-form-item label="交易单号">
          <el-input v-model="searchForm.withdrawId" placeholder="请输入单号" />
        </el-form-item>
        <el-form-item label="提现方式">
          <el-select v-model="searchForm.type" placeholder="请选择提现方式">
            <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button style="margin-left:12px" type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- <div class="tilte-text"> 资金明细 </div>
    <div class="search-wrap" style="margin-top: 20px;">
      <template>
        <span>提现金额</span>
        <Input v-model="searchForm.amountMix" placeholder="提现金额" style="width: 150px;" />
        <span style="padding: 0 5px;">至</span>
        <Input v-model="searchForm.amountMax" placeholder="提现金额" style="width: 150px;" />
      </template>
      <template>
        <span style="padding-left: 20px;">选择时间</span>
        <DatePicker type="date" placeholder="提现时间" v-model="searchForm.createStartTime" style="width: 150px;">
        </DatePicker>
        <span style="padding: 0 5px;">至</span>
        <DatePicker type="date" placeholder="提现时间" v-model="searchForm.createEndTime"></DatePicker>
      </template>
      <template>
        <span style="padding-left: 20px;">选择时间</span>
        <DatePicker type="date" placeholder="处理提现时间" v-model="searchForm.doneStartTime" style="width: 150px;">
        </DatePicker>
        <span style="padding: 0 5px;">至</span>
        <DatePicker type="date" placeholder="处理提现时间" v-model="searchForm.doneEndTime"></DatePicker>
      </template>
      <template>
        <span style="padding-left: 20px;">交易单号</span>
        <Input v-model="searchForm.withdrawId" placeholder="请输入单号" style="width: 150px;" />
      </template>
      <template>
        <span style="padding-left: 20px;">提现方式</span>
        <Select v-model="searchForm.type" style="width:150px" placeholder="全部">
          <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </template>
      <template>
        <Button type="text" style="background: #FF8622;color: #FFFFFF;" @click="onFormSearch">查询</Button>
      </template>
    </div> -->
    <div class="block block-top">
      <Table border :columns="columns" :data="list" :loading="listLoading">
        <template slot-scope="{ row }" slot="state">
          <span>{{ getStateText(row.status) }}</span>
        </template>
        <template slot-scope="{ row }" slot="type">
          <span class="color-ff9" v-if="row.type == 1">支付宝</span>
          <span class="color-666" v-if="row.type == 2">微信</span>
          <span class="color-666" v-if="row.type == 3">银行卡</span>
        </template>
      </Table>
      <div style="padding: 10px 0px">
        <Page :total="total" :current="searchForm.pageNo" show-sizer show-elevator show-total @on-change="changePage"
          @on-page-size-change="changePagesize"></Page>
      </div>
    </div>
  </div>
</template>
<script>
import { getPlatformUuid } from '@/utils/auth'
import { Icon, Table, Page, Button, Option, Input, DatePicker, Select } from 'view-design'
import { getDate } from '@/utils/date'
import withdraw from '@/javaApi/withdraw.js'
const withdrawModel = new withdraw()
export default {
  name: 'Member',
  components: {
    Icon,
    Table,
    Page,
    Button,
    Option,
    Input,
    DatePicker,
    Select
  },
  data: function () {
    return {
      columns: [
        {
          title: '序号',
          key: 'sequence'
        },
        {
          title: '交易单号',
          key: 'withdrawId'
        },
        {
          title: '真实姓名',
          key: 'receiveRealName',
        },
        {
          title: '收款账号',
          key: 'receiveAccount'
        },
        {
          title: '提现金额',
          key: 'withdrawal',
        },
        {
          title: '提现方式',
          key: 'type',
          slot: 'type'
        },
        {
          title: '实际打款金额',
          key: 'actualWithdrawal'
        },
        {
          title: '提现时间',
          key: 'createTimeStr',
        },
        {
          title: '打款时间',
          key: 'doneTimeStr',
        },
        {
          title: '提现状态',
          key: 'state',
          slot: 'state'
        }
      ],
      listLoading: false,
      list: [
      ],
      total: 0,
      platformUuid: getPlatformUuid(),
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        id: undefined,
        amountMix: undefined,
        amountMax: undefined,
        createStartTime: undefined,
        createEndTime: undefined,
        doneEndTime: undefined,
        doneStartTime: undefined,
        type: undefined,
        withdrawId: undefined
      },
      // 提现方式
      typeList: [
        { "label": "全部", "value": "" },
        { "label": "支付宝", "value": "1" },
        { "label": "微信", "value": "2" },
        { "label": "银行卡", "value": "3" },
      ]
    }
  },
  created() {
    this.getList(true)
  },
  methods: {
    getList(first = false) {
      let that = this
      this.listLoading = true
      if (first) this.searchForm.pageNo = 1
      let searchForm = Object.assign({}, this.searchForm)
      searchForm.createStartTime = getDate(searchForm.createStartTime)
      if (searchForm.createStartTime) {
        searchForm.createStartTime = searchForm.createStartTime + ' 00:00:00'
      } else {
        delete searchForm.createStartTime
      }

      searchForm.createEndTime = getDate(searchForm.createEndTime)

      if (searchForm.createEndTime) {
        searchForm.createEndTime = searchForm.createEndTime + ' 23:59:59'
      } else {
        delete searchForm.createEndTime
      }

      searchForm.doneStartTime = getDate(searchForm.doneStartTime)
      if (searchForm.doneStartTime) {
        searchForm.doneStartTime = searchForm.doneStartTime + ' 00:00:00'
      } else {
        delete searchForm.doneStartTime
      }
      searchForm.doneEndTime = getDate(searchForm.doneEndTime)
      if (searchForm.doneEndTime) {
        searchForm.doneEndTime = searchForm.doneEndTime + ' 23:59:59'
      } else {
        delete searchForm.doneEndTime
      }
      if (!searchForm.withdrawMix) {
        delete searchForm.withdrawMix
      }
      if (!searchForm.withdrawMax) {
        delete searchForm.withdrawMax
      }
      let condition = (this.platformUuid == '' || this.platformUuid == 0);
      if (!condition) {
        searchForm.platformUuid = this.platformUuid
      }
      searchForm = this.formateInit(searchForm)
      console.log('searchForm', searchForm)
      withdrawModel.getWithdrawList(searchForm).then(response => {
        that.listLoading = false
        let res = response.data
        if (res.code == 200) {
          if (res.data) {
            this.list = res.data.list ? res.data.list : []
            this.list = this.formateData(this.list)
            this.total = res.data.total ? res.data.total : 0
          }
        } else {
          let message = res.message ? res.message : '系统异常,请稍后再试！'
          that.$Message.error(message)
        }
      }).catch(error => {
        console.log(error)
        that.listLoading = false
        if (error != 'token invalid') {
          this.$Message.error('系统异常请稍后再试！')
        }
      })
    },
    formateData(data) {
      if (!data) {
        return []
      }
      if (!data.length) {
        return []
      }
      let i = 0;
      let pageNo = this.searchForm.pageNo
      let pageSize = this.searchForm.pageSize
      for (i = 0; i < data.length; i++) {
        data[i].sequence = (i + 1) + (pageNo - 1) * pageSize
        // 处理当是银行卡提现时显示收款账户银行卡数据
        if (data[i].receiveAccount == '') {
          data[i].receiveAccount = data[i].bankCardNum
        }
      }
      return data
    },
    getStateText(state) {
      // 提现状态：1 待处理，2 提现成功，3 提现失败，4 微信打款失败(二次触发提现不改订单)，5 打款中
      let text = ''
      switch (parseInt(state)) {
        case 1:
          text = '待处理'
          break;
        case 2:
          text = '提现成功'
          break;
        case 3:
          text = '提现失败'
          break;
        case 4:
          text = '微信打款失败'
          break;
        case 5:
          text = '打款中'
          break;
        default:
          text = '暂时没有状态'
      }
      return text
    },
    onFormSearch() {
      this.getList(true)
    },
    onFormReset() {
      this.searchForm.id = undefined
      this.searchForm.amountMix = undefined
      this.searchForm.amountMax = undefined
      this.searchForm.createStartTime = undefined
      this.searchForm.createEndTime = undefined
      this.searchForm.doneEndTime = undefined
      this.searchForm.doneStartTime = undefined
      this.searchForm.type = undefined
      this.searchForm.withdrawId = undefined

      this.onFormSearch()
    },
    changePage(value) {
      this.searchForm.pageNo = value
      this.getList()
    },
    changePagesize(value) {
      this.searchForm.pageSize = value;
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchForm.pageNo == 1) {
        this.getList()
      }
    },
    formateInit(formData) {
      let objCopy = {};
      for (let key in formData) {
        if (formData[key]) {
          objCopy[key] = formData[key];
        }
      }
      return objCopy;
    },
  }
}
</script>
<style scoped>
.wrapper {
  width: 100%;
  font-size: 12px;
}

.wrapper .tilte-text {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper .table-wrapper {
  margin-top: 30px;
}

.search-wrap .ivu-icon-ios-arrow-down:before {
  color: #232323;
  content: "\F33D";
}

.ivu-date-picker-rel {
  margin: 11px 0;
}

.ivu-table {
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  border-radius: 2px;
}

.table-wrapper .ivu-table-header th {
  background-color: #FCFAF8 !important;
}

.table-wrapper .ivu-table-header th .ivu-table-cell {
  color: #222222 !important;
}

.table-wrapper .ivu-table-wrapper-with-border {
  border: none;
}

.table-wrapper .ivu-table-wrapper-with-border {
  border-radius: 0px;
  border-color: #FFFFFF !important;
}

.block-tilte {
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  margin-bottom: 24px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/official/withdraw/Index.vue